// Single source of truth for the marketing + authenticated-dashboard origins.
//
// Marketing-site CTAs (Log in, Register, "Post your first shift") need to
// hard-redirect across origins to the dashboard subdomain in production,
// but in development everything runs on a single localhost origin so
// cross-origin would just break the flow. The same applies to the
// dashboard logos that should bounce users back to the marketing home.
//
// Both helpers resolve to an absolute URL in prod and a same-origin path
// in dev, so click-throughs work seamlessly in both environments.

// dashboard.tempdash.app, NOT the old dental.tempdash.app: the dashboard serves
// every sector (dentistry, social care, …) identically, so the hostname carries no
// sector. dental.tempdash.app was V1 and is being retired — pointing CTAs at it
// would send every "Log in" / "Post a shift" click to a dead host.
// Overridable so a preview deploy can aim at a different dashboard.
const PROD_DASHBOARD  = import.meta.env.VITE_DASHBOARD_URL || 'https://dashboard.tempdash.app'
const PROD_MARKETING  = 'https://tempdash.app'

export function dashboardUrl(path = '/') {
  if (import.meta.env.PROD) return `${PROD_DASHBOARD}${path}`
  return path
}

export function marketingUrl(path = '/') {
  if (import.meta.env.PROD) return `${PROD_MARKETING}${path}`
  return path
}
